import image_1 from 'asset/block_icon_1.svg';
import image_2 from 'asset/block_icon_2.svg';
import image_3 from 'asset/block_icon_3.svg';
import image_4 from 'asset/block_icon_4.svg';

export const data_use_instructions = {
  prefix: 'Benefits',
  title: 'Leverage XR Design Pro to change your design game',
  items: [
    {
      id: 1,
      image: image_1,
      title: 'Rapid&nbsp;Design',
      description:
        'Reduce time spent in product design cycles with high-fidelity digital replicas. Powered by NVIDIA RTX™, your experience your physical assets with accurate materials and lighting.',
    },
    {
      id: 2,
      image: image_2,
      title: 'Cohesive Collaboration',
      description:
        'Work with teams across locations in a shared virtual space, enabling your rapid exchange and evaluations of design ideas.',
    },
    {
      id: 3,
      image: image_3,
      title: 'Seamless Integration',
      description:
        'Connect SoftServe XR Design Pro with leading design tools. Leverage professional grade design applications like Autodesk Alias, DeltaGen, and Siemens in virtual and mixed reality.',
    },
    {
      id: 4,
      image: image_4,
      title: 'At-Scale Experience',
      description:
        'Interact with virtual objects at their actual scale. Workers and customers acquire an intuitive understanding of physical assets before they become physical reality.',
    },
  ],
};
